import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import {
  InputProps,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@e2n/ui';
import { cn } from '@/lib/utils';
import { faEuro } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

const numberMaskingOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: '.',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  decimalSeparator: ',',
  min: 0,
});

export function FieldMoneyInput({
  label,
  description,
  isRequired,
  placeholder,
  className,
  infoText,
  ...inputProps
}: FieldProps & InputProps) {
  const field = useFieldContext<string>();
  const ref = useMaskito({ options: numberMaskingOptions });
  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      infoText={infoText}>
      <InputGroup className={cn(className, 'h-10')}>
        <InputGroupInput
          id={field.name}
          value={field.state.value ?? ''}
          ref={ref}
          placeholder={placeholder}
          onBlur={field.handleBlur}
          inputMode="numeric"
          onChange={(e) => field.handleChange(e.target.value)}
          {...inputProps}
        />
        <InputGroupAddon align={'inline-end'}>
          <FontAwesomeIcon
            icon={faEuro}
            className="size-3.5 text-neutrals-700"
          />
        </InputGroupAddon>
      </InputGroup>
    </FieldBase>
  );
}
